import { OTPField } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import type { PostConnectOrganizationSchema } from "@msuite/utils/schemas";
import { useFormContext } from "react-hook-form";

export function ConnectPartnerForm() {
	/** Hooks */
	const { t } = useTranslation();
	const methods = useFormContext<PostConnectOrganizationSchema>();

	/** Render */
	return (
		<div className="v-stack gap-4">
			<p className="label">{t("organization.connect_organization_description")}</p>
			{/* Twelve plain characters — the connect schema inserts the hyphen of the wire format. */}
			<OTPField
				isRequired
				label={t("organization.partnership_invitation_code")}
				control={methods.control}
				name="code"
				length={12}
				divideIndex={[4]}
			/>
		</div>
	);
}
